<app-loader *ngIf="moveBrigadeLoading"></app-loader>
<div class="modal__header">
  <span class="title">{{ title }}</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXMoveUser"></div>
</div>
<div class="modal__body">
  {{ description }}

  <div class="mt-16" *ngIf="mode === 'moveBrigadeHead'">
    <app-field>
      <label>Новый бригадир в текущей бригаде</label>
      <app-combobox
        [items]="brigadeHeadListInBrigade"
        (callback)="onChangeSelectedNewBrigadeHead($event)"
        [textKey]="'full_name'"
        [defaultText]="'Выберите бригадира'"
        [initBy]="brigadeHeadNewSelected"
        [name]="'newBrigadeHead'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="mode === 'moveUser' && !currentBrigade">
    <app-field>
      <label>Новая бригада</label>
      <app-combobox
        [items]="brigadeList"
        (callback)="onChangeSelectedMoveBrigade($event)"
        [textKey]="'brigade_name'"
        [defaultText]="'Выберите бригаду'"
        [initBy]="brigadeSelected"
        [name]="'newBrigade'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="mode === 'moveUser' && currentBrigade">
    <app-field>
      <label>Новая бригада</label>
      <app-combobox
        [items]="brigadeListWithOthCurrentBrigade"
        (callback)="onChangeSelectedMoveBrigade($event)"
        [textKey]="'brigade_name'"
        [defaultText]="'Выберите бригаду'"
        [initBy]="brigadeSelected"
        [name]="'newBrigade'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="mode === 'moveBrigadeHead' || mode === 'moveBrigadeHeadAndDrop'">
    <app-field>
      <label>Новая бригада</label>
      <app-combobox
        [items]="brigadeListWithOthCurrentBrigade"
        (callback)="onChangeSelectedMoveBrigade($event)"
        [textKey]="'brigade_name'"
        [defaultText]="'Выберите бригаду'"
        [initBy]="brigadeSelected"
        [name]="'newBrigade'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" [disabled]="!brigadeSelected" (click)="onMoveUserNewBrigade()" id="appMoveUserInNewBrigade">Перенести</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseMoveUser"> Отмена </a>
  </div>
</div>
